module.exports = __webpack_public_path__ + "img/142.7.cad925b8.png";